import { useState, useEffect } from "react";
import axios from "axios";
import Config from "../Config";

interface Faq {
    id: string;
    heading: string;
    content: string;
    page?: string;
}

export const useFaqData = () => {
    const [faqSections, setFaqSections] = useState<Faq[]>([]);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        const fetchFaqData = async () => {
            try {
                const response = await axios.get<Faq[]>(`${Config.apiUrl}/Contents/${Config.tenant}/tenant/faq`);
                setFaqSections(response.data);
            } catch (err) {
                setError("Failed to load FAQ data.");
                console.error(err);
            }
        };

        fetchFaqData();
    }, []);

    return { faqSections, error };
};